// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JiWA","comment":"styles_comment__1bJsW"};